import { For } from 'solid-js';
import { useTranslation } from '../hooks/useTranslation';
import styles from './DateRangePills.module.css';

export type DateRangeValue = 'all' | 'today' | '7d' | '30d';

interface Pill<T extends string> {
    value: T;
    labelKey: string;
}

const DEFAULT_PILLS: Pill<DateRangeValue>[] = [
    { value: 'all',   labelKey: 'DATE_RANGE_ALL' },
    { value: 'today', labelKey: 'DATE_RANGE_TODAY' },
    { value: '7d',    labelKey: 'DATE_RANGE_7D' },
    { value: '30d',   labelKey: 'DATE_RANGE_30D' },
];

interface DateRangePillsProps<T extends string> {
    value: T;
    onChange: (next: T) => void;
    pills?: Pill<T>[];
}

export function DateRangePills<T extends string = DateRangeValue>(props: DateRangePillsProps<T>) {
    const { t } = useTranslation();
    const pills = () => props.pills ?? (DEFAULT_PILLS as unknown as Pill<T>[]);

    return (
        <div class={styles.quickFilters}>
            <For each={pills()}>
                {(pill) => (
                    <button
                        type="button"
                        aria-pressed={props.value === pill.value}
                        class={`${styles.quickFilter} ${props.value === pill.value ? styles.quickFilterActive : ''}`}
                        onClick={() => props.onChange(pill.value)}
                    >
                        {t(pill.labelKey)}
                    </button>
                )}
            </For>
        </div>
    );
}
